module.exports = __webpack_public_path__ + "media/images/marisol-logo-a1b15ca86b9795faa0ae3e7d6c84de99.png";